import { PlatformType } from '../../../../platform_type';
import { InstallConversionTrackingComponent } from '../../content/shopify/install_conversion_tracking.component';
import { InstallReviewsWidgetComponent } from '../../content/shopify/install_reviews_widget.component';
import { WooAddJavascriptComponent } from '../../content/woocommerce/woo_add_javascript.component';
import { WooActivatePluginComponent } from '../../content/woocommerce/woo_activate_plugin.component';
import { WooSetupComponent } from '../../content/woocommerce/woo_setup.component';
import { ShopifyAddJavascriptComponent } from '../../content/shopify/shopify_add_javascript.component';
import { BigcommerceBuiltinReviewsComponent } from '../../content/bigcommerce/bigcommerce_builtin_reviews.component';
import { BigcommerceInstallAppComponent } from '../../content/bigcommerce/bigcommerce_install_app.component';
import { BigcommerceInstallWidgetComponent } from '../../content/bigcommerce/bigcommerce_install_widget.component';
import { BigcommerceInstallTrackingComponent } from '../../content/bigcommerce/bigcommerce_install_tracking.component';
import { Magento1ReenableCompilationComponent } from '../../content/magento1/magento1_reenable_compilation.component';
import { Magento1DisableBuiltinReviewsComponent } from '../../content/magento1/magento1_disable_builtin_reviews.component';
import { Magento1LoadPastPurchasesComponent } from '../../content/magento1/magento1_load_past_purchases.component';
import { Magento1InstallYotpoWidgetComponent } from '../../content/magento1/magento1_install_yotpo_widget.component';
import { Magento1DisableCompilationComponent } from '../../content/magento1/magento1_disable_compilation.component';
import { Magento1InstallExtensionComponent } from '../../content/magento1/magento1_install_extension.component';
import { Magento2EnableYotpoModuleComponent } from '../../content/magento2/magento2_enable_yotpo_module.component';
import {
  HYBRIS_INSTALLATION_LINK,
  OPENCART_INSTALLATION_LINK, OTHER_INSTALLATION_LINK, PRESTASHOP_INSTALLATION_LINK, SFMC_INSTALLATION_LINK,
  VOLUSION_INSTALLATION_LINK,
} from '../../../../../shared/navigation/constants';

export const defaultManualSetupStates = {};
defaultManualSetupStates[PlatformType.Shopify] = [
  {
    template: ShopifyAddJavascriptComponent,
    id: 'shopifyJavascript',
    title: 'MANUAL_SETUP.SHOPIFY.ADD_YOTPOS_JAVA_SCRIPT.TITLE',
    description: 'MANUAL_SETUP.SHOPIFY.ADD_YOTPOS_JAVA_SCRIPT.DESCRIPTION',
    timeToComplete: 2
  },
  {
    template: InstallReviewsWidgetComponent,
    id: 'shopifyWidget',
    title: 'MANUAL_SETUP.SHOPIFY.INSTALL_REVIEWS_WIDGET.TITLE',
    description: 'MANUAL_SETUP.SHOPIFY.INSTALL_REVIEWS_WIDGET.DESCRIPTION',
    timeToComplete: 2
  },
  {
    template: InstallConversionTrackingComponent,
    id: 'shopifyTracking',
    title: 'MANUAL_SETUP.SHOPIFY.INSTALL_CONVERSION_TRACKING.TITLE',
    description: 'MANUAL_SETUP.SHOPIFY.INSTALL_CONVERSION_TRACKING.DESCRIPTION',
    timeToComplete: 2
  }];

defaultManualSetupStates[PlatformType.Woocommerce] = [
  {
    template: WooAddJavascriptComponent,
    id: 'woocommerceJavascript',
    title: 'MANUAL_SETUP.WOOCOMMERCE.INTALL_YOTPO_PLUGIN.TITLE',
    description: 'MANUAL_SETUP.WOOCOMMERCE.INTALL_YOTPO_PLUGIN.DESCRIPTION',
    timeToComplete: 1
  },
  {
    template: WooActivatePluginComponent,
    id: 'woocommercePlugin',
    title: 'MANUAL_SETUP.WOOCOMMERCE.ACTIVATE_PLUGIN.TITLE',
    description: 'MANUAL_SETUP.WOOCOMMERCE.ACTIVATE_PLUGIN.DESCRIPTION',
    timeToComplete: 1
  },
  {
    template: WooSetupComponent,
    id: 'woocommerceSetup',
    title: 'MANUAL_SETUP.WOOCOMMERCE.SETUP_YOTPO.TITLE',
    description: 'MANUAL_SETUP.WOOCOMMERCE.SETUP_YOTPO.DESCRIPTION',
    timeToComplete: 1
  }];

defaultManualSetupStates[PlatformType.Bigcommerce] = [
  {
    template: BigcommerceBuiltinReviewsComponent,
    id: 'bigcommerceReviews',
    title: 'MANUAL_SETUP.BIGCOMMERCE.DISABLE_BUILTIN_REVIEWS_SYSTEM.TITLE',
    description: 'MANUAL_SETUP.BIGCOMMERCE.DISABLE_BUILTIN_REVIEWS_SYSTEM.DESCRIPTION',
    timeToComplete: 2
  },
  {
    template: BigcommerceInstallAppComponent,
    id: 'bigcommerceInstall',
    title: 'MANUAL_SETUP.BIGCOMMERCE.INSTALL_THE_YOTPO_APP.TITLE',
    description: 'MANUAL_SETUP.BIGCOMMERCE.INSTALL_THE_YOTPO_APP.DESCRIPTION',
    timeToComplete: 1
  },
  {
    template: BigcommerceInstallWidgetComponent,
    id: 'bigcommerceWidget',
    title: 'MANUAL_SETUP.BIGCOMMERCE.INSTALL_JAVASCRIPT_AND_WIDGET.TITLE',
    description: 'MANUAL_SETUP.BIGCOMMERCE.INSTALL_JAVASCRIPT_AND_WIDGET.DESCRIPTION',
    timeToComplete: 2
  },
  {
    template: BigcommerceInstallTrackingComponent,
    id: 'bigcommerceTracking',
    title: 'MANUAL_SETUP.BIGCOMMERCE.INSTALL_CONVERSION_TRACKING.TITLE',
    description: 'MANUAL_SETUP.BIGCOMMERCE.INSTALL_CONVERSION_TRACKING.DESCRIPTION',
    timeToComplete: 1
  }];

defaultManualSetupStates[PlatformType.Magento] = [
  {
    template: Magento1DisableCompilationComponent,
    title: 'MANUAL_SETUP.MAGENTO_1.DISABLE_COMPILATION.TITLE',
    id: 'magento1Disable',
    description: 'MANUAL_SETUP.MAGENTO_1.DISABLE_COMPILATION.DESCRIPTION',
    timeToComplete: 1
  },
  {
    template: Magento1InstallExtensionComponent,
    title: 'MANUAL_SETUP.MAGENTO_1.INSTALL_YOTPO_EXTENSION.TITLE',
    id: 'magento1InstallExtension',
    description: 'MANUAL_SETUP.MAGENTO_1.INSTALL_YOTPO_EXTENSION.DESCRIPTION',
    timeToComplete: 3
  },
  {
    template: Magento1InstallYotpoWidgetComponent,
    title: 'MANUAL_SETUP.MAGENTO_1.INSTALL_REVIEWS_WIDGET.TITLE',
    id: 'magento1InstallWidget',
    description: 'MANUAL_SETUP.MAGENTO_1.INSTALL_REVIEWS_WIDGET.DESCRIPTION',
    timeToComplete: 1
  },
  {
    template: Magento1LoadPastPurchasesComponent,
    title: 'MANUAL_SETUP.MAGENTO_1.LOAD_PAST_PURCHASES.TITLE',
    id: 'magento1PastPurchases',
    description: 'MANUAL_SETUP.MAGENTO_1.LOAD_PAST_PURCHASES.DESCRIPTION',
    timeToComplete: 1
  },
  {
    template: Magento1DisableBuiltinReviewsComponent,
    title: 'MANUAL_SETUP.MAGENTO_1.DISABLE_BUILTIN_REVIEWS_SYSTEM.TITLE',
    id: 'magento1DisableBuiltinReviews',
    description: 'MANUAL_SETUP.MAGENTO_1.DISABLE_BUILTIN_REVIEWS_SYSTEM.DESCRIPTION',
    timeToComplete: 1
  },
  {
    template: Magento1ReenableCompilationComponent,
    title: 'MANUAL_SETUP.MAGENTO_1.RE_ENABLE_COMPILATION.TITLE',
    id: 'magento1ReenableCompilation',
    description: 'MANUAL_SETUP.MAGENTO_1.RE_ENABLE_COMPILATION.DESCRIPTION',
    timeToComplete: 1
  }];

defaultManualSetupStates[PlatformType.Magento2] = [
  {
    template: Magento2EnableYotpoModuleComponent,
    id: 'magento2EnableYotpoModule',
    title: 'MANUAL_SETUP.MAGENTO_2.ENABLE_YOTPO_MODULE.TITLE',
    description: 'MANUAL_SETUP.MAGENTO_2.ENABLE_YOTPO_MODULE.DESCRIPTION',
    timeToComplete: 1
  }
];

defaultManualSetupStates[PlatformType.Volusion] = [
  {
    installationGuideLink: VOLUSION_INSTALLATION_LINK
  }
];

defaultManualSetupStates[PlatformType.Volusion2] = [
  {
    installationGuideLink: VOLUSION_INSTALLATION_LINK
  }
];

defaultManualSetupStates[PlatformType.Prestashop] = [
  {
    installationGuideLink: PRESTASHOP_INSTALLATION_LINK
  }
];

defaultManualSetupStates[PlatformType.Opencart] = [
  {
    installationGuideLink: OPENCART_INSTALLATION_LINK
  }
];

defaultManualSetupStates[PlatformType.SalesforceMarketingCloud] = [
  {
    installationGuideLink: SFMC_INSTALLATION_LINK
  }
];

defaultManualSetupStates[PlatformType.Hybris] = [
  {
    installationGuideLink: HYBRIS_INSTALLATION_LINK
  }
];

defaultManualSetupStates[PlatformType.Other] = [
  {
    installationGuideLink: OTHER_INSTALLATION_LINK
  }
];


